import { observer } from 'mobx-react';

import { useStores } from '../../stores/useStores';

import RiveFilePreloader from './RiveFilePreloader';

const RiveFilePreloaderGroup = observer(() => {
  const { riveFileStore } = useStores();
  const { allFilesToPreload } = riveFileStore;

  if (allFilesToPreload.length === 0) {
    return null;
  }

  return (
    <div>
      {allFilesToPreload.map((url) => (
        <RiveFilePreloader key={url} url={url} />
      ))}
    </div>
  );
});

export default RiveFilePreloaderGroup;
